/** Prefix for All Issues filter persistence in sessionStorage. */
export const ISSUE_FILTER_STORAGE_PREFIX = 'trace:issue-filters:';

/** Removes all sessionStorage keys that start with `prefix`. */
export function clearSessionStorageByPrefix(prefix: string): void {
  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key?.startsWith(prefix)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch {
  }
}

/** Clears all persisted All Issues filters (call on logout / 401). */
export function clearIssueFiltersFromSession(): void {
  clearSessionStorageByPrefix(ISSUE_FILTER_STORAGE_PREFIX);
}
